import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { Stack, Typography } from "@mui/material";
import MarimekkoChart from "components/Reports/ReusableComponents/MarimekkoChart/MarimekkoChart";
import { fastapiVmInstance } from "utils/AxiosInstances/RareboxFastApi";
import DounutRelatedCards from "../DounutRelatedCards/DounutRelatedCards";
import DounutChart from "components/Reports/ReusableComponents/DounutChart/DounutChart";
import { dounuts } from "../DounutRelatedCards/data";
import StoreList from "components/Reports/ReusableComponents/StoreList/StoreList";
import ConnectedStackedBarChart from "components/Reports/ReusableComponents/ConnectedStackBarChart/ConnectedStackBarChart";
import ConnectedStackBarSkeleton from "components/Reports/ReusableComponents/ConnectedStackBarChart/ConnectedStackBarSkeleton";

const ChannelRelatedCards = ({ filter, width=800, height=680, color
 }) => {
    const { setSnackBarOpen, setSnackBar, snackbar } = GlobalState();
    const [loading, setLoading] = useState(true);
    const [mrpData, setMrpData] = useState([]);

    const fetch = async () => {
        try {
            setLoading(true);
            const body = { filter };
            console.log('awdfgahijodklajsdh', filter)

            const res = await fastapiVmInstance.post(`/api/summary-report/summary-stacked-bar-graph-bucket`, {filter});

            if (res.data.status === "error") throw new Error(res.data?.message);
            const result = res.data.result;
            setMrpData(result)
            
            setLoading(false);
        } catch (error) {
            setSnackBarOpen(true);
            setSnackBar({
                message: parseErrMsgFromError(error),
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };


    useEffect(() => {

        fetch();

    }, [filter]);

        return (
            <Stack width={width} height={height}
                sx={{
                    background: "white",
                }}
            >
                <Typography sx={{fontSize: "var(--font-size-h2)"}} margin="20px 0px 20px 30px">CHANNEL DEEP-DIVE (Draft)</Typography>
                <ConnectedStackedBarChart data= {mrpData} width={width} height={height - 80} loading = {loading} colors={color}/>
			</Stack>
        );
};

export default ChannelRelatedCards;
